//A collection of shared types that can be used across AS tests
export enum SampleHistory {
  Natural = 'Natural state',
  AirDried = 'Air-dried',
  OvenDried = 'Oven-dried',
  Unknown = 'Unknown',
}
export enum PreparationMethod {
  Wet = 'Wet',
  Dry = 'Dry',
  Natural = 'Natural state',
}
export enum OversizeMaterialRemovedBy {
  Mortar_Pestle = 'Mortar and pestle',
  Mechanical = 'Mechanical device',
}

//These all have qest enums defined
export enum MaterialConditionAsTested {
  Natural = 1,
  Rubbed = 2,
}
export enum WashingMethod {
  FullWash = 1,
  SprayWash = 2,
}
export enum MaterialDriedBy {
  Air = 1,
  Oven = 2,
}
